<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      v-model="model"
      :error="errors"
      id="input-bank_account_address_2"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import InputWidget from "../../../core/InputWidget";
import BaseInputMixin from "@/mixins/profileInputMixin";

export default {
  name: "BankAccountAddress2",
  components: {InputWidget},
  mixins: [BaseInputMixin('bank_account.address_2')],

  data() {
    return {
      name: 'address_2',
      defaultLabel: this.$t("Address 2")
    }
  }
}
</script>

<style scoped>

</style>
